import { IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { DataKey } from 'enums/DataKey';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { IError } from 'interfaces/sessionVerification/plays/IPlayPreviewRow';
import { IReviewPlayerExtended } from 'interfaces/IReviewPlayer';
import { PositionDict } from 'enums/PositionDictionary';
import { isNotDuplicated, isNotSamePosition, playerHasNoEmptyGuid } from './playerValidationHelpers';

export const defensivePlayerValidator: IDataGridValidator = {
  validate: (rows: PlayRow[], columns: IDataGridColumnConfiguration[]) => {
    // @ts-ignore
    const columnObj = {} as { [key: Record<DataKey, IDataGridColumnConfiguration>] };

    for (const column of columns) {
      // @ts-ignore
      columnObj[column.dataKey] = column;
    }

    // @ts-ignore
    const { firstBaseman, secondBaseman, thirdBaseman, shortStopper, leftFielder, centerFielder, rightFielder } = columnObj;

    if (!firstBaseman || !secondBaseman || !thirdBaseman || !shortStopper || !leftFielder || !centerFielder || !rightFielder) {
      return rows.map(() => []);
    }

    return rows.map((r) =>
      validateRow(r, firstBaseman, secondBaseman, thirdBaseman, shortStopper, leftFielder, centerFielder, rightFielder)
    );
  },
};

const validateRow = (
  row: PlayRow,
  firstBasemanColumn: IDataGridColumnConfiguration,
  secondBasemanColumn: IDataGridColumnConfiguration,
  thirdBasemanColumn: IDataGridColumnConfiguration,
  shortStopperColumn: IDataGridColumnConfiguration,
  leftFielderColumn: IDataGridColumnConfiguration,
  centerFielderColumn: IDataGridColumnConfiguration,
  rightFielderColumn: IDataGridColumnConfiguration
): IError[] => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }

  const firstBaseman = { ...row[firstBasemanColumn.dataKey], defaultPosition: firstBasemanColumn.dataKey } as IReviewPlayerExtended;
  const secondBaseman = { ...row[secondBasemanColumn.dataKey], defaultPosition: secondBasemanColumn.dataKey } as IReviewPlayerExtended;
  const thirdBaseman = { ...row[thirdBasemanColumn.dataKey], defaultPosition: thirdBasemanColumn.dataKey } as IReviewPlayerExtended;
  const shortStopper = { ...row[shortStopperColumn.dataKey], defaultPosition: shortStopperColumn.dataKey } as IReviewPlayerExtended;
  const leftFielder = { ...row[leftFielderColumn.dataKey], defaultPosition: leftFielderColumn.dataKey } as IReviewPlayerExtended;
  const centerFielder = { ...row[centerFielderColumn.dataKey], defaultPosition: centerFielderColumn.dataKey } as IReviewPlayerExtended;
  const rightFielder = { ...row[rightFielderColumn.dataKey], defaultPosition: rightFielderColumn.dataKey } as IReviewPlayerExtended;

  const defensivePositions = [firstBaseman, secondBaseman, thirdBaseman, shortStopper, leftFielder, centerFielder, rightFielder];

  defensivePositions.forEach((firstPlayer) => {
    const fpPosition = PositionDict[firstPlayer.defaultPosition];

    if (!firstPlayer.id) {
      errors.push({
        dataKey: `${firstPlayer.defaultPosition}`,
        errorMessage: `${fpPosition} cannot be undefined`,
      });

      return;
    }

    defensivePositions.forEach((secondPlayer) => {
      if (!secondPlayer.id) {
        return;
      }

      const fpPosition = PositionDict[firstPlayer.defaultPosition];
      const spPosition = PositionDict[secondPlayer.defaultPosition];

      if (
        isNotSamePosition(firstPlayer, secondPlayer) &&
        isNotDuplicated(fpPosition, spPosition, errors) &&
        playerHasNoEmptyGuid(firstPlayer, secondPlayer)
      ) {
        errors.push({
          dataKey: `${firstPlayer.defaultPosition}-${secondPlayer.defaultPosition}`,
          errorMessage: `${fpPosition} is same as ${spPosition}`,
        });
      }
    });
  });

  return errors;
};
